export const parseEnumQueryParam = <T extends Record<string, string>>(
  value: string | null | undefined,
  enumObj: T,
): T[keyof T] | null => {
  if (!value) return null
  const validValues = Object.values(enumObj) as string[]
  if (validValues.includes(value)) return value as T[keyof T]
  return null
}
